import { Outlet } from "react-router-dom"
const MainCostings = () =>{

    return(
        <div className=" w-full h-full">
         <Outlet/>
        </div>
    )
}


export default MainCostings;